import moment from 'moment';

export function formatPriceWithComma(price){
	let formatedPrice = parseFloat(price).toFixed(2);
	formatedPrice = formatedPrice.toString().replace(/(\D)+(?!.*\1)/,",");
	formatedPrice = formatedPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return formatedPrice;
}

export function formatDate(date, pattern ){
	return moment(date).format(pattern);
}



// WEBPACK FOOTER //
// ./src/assets/format.js